<template>
    <div>
        <div class="voice-message-pick-list__item-content">
            <div class="voice-message-pick-list__item-title">{{ title }}</div>
            <div class="voice-message-pick-list__item-desc">{{ description }}</div>
        </div>
        <div class="voice-message-pick-list__item-tags ml-2">
            <i v-show="false" class="fas fa-star"></i>
            <span v-if="isForeign" class="badge badge-purple">shared by {{ ownerName }}</span>
        </div>
        <div class="voice-message-pick-list__item-actions ml-2">
            <button class="btn btn-secondary btn-sm" @click="select(id)" :disabled="hasActive">
                <i class="fas fa-spinner fa-spin" v-if="isActive"></i>
                <i class="fas fa-play" v-else></i>
            </button>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      item: Object,
      active: Number,
    },

    computed: {
      /**
       * @return {number}
       */
      id() {
        return _.get(this.item, 'id');
      },

      /**
       * @return {string}
       */
      title() {
        return _.get(this.item, 'title');
      },

      /**
       * @return {string}
       */
      description() {
        return _.get(this.item, 'description');
      },

      /**
       * @return {boolean}
       */
      isActive() {
        return this.id === this.active
      },

      /**
       * @return {boolean}
       */
      hasActive() {
        return Boolean(this.active);
      },

      /**
       * @return {boolean}
       */
      isForeign() {
        return !_.get(this.item, 'is_own', false);
      },

      /**
       * @return {string}
       */
      ownerName() {
        return _.get(this.item, 'user.first_name');
      },
    },

    methods: {
      /**
       * @emits select
       */
      select() {
        this.$emit('select', this.id);
      },
    },
  }
</script>
